// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8bbc1509","455":"fbe58476","977":"0ac63755"}[chunkId] + ".chunk.js";
};